import {BaseAnimation} from './BaseAnimation';

export class ClipInsetAnimation extends BaseAnimation {

    private hasFrom=false;
    private hasTo=false;
    private resetAfter=false;

    public getClass():string {
        return 'clip-inset-animation';
    }

    protected isValidProperty(prop:string) {
        return prop=='clip-path';
    }

    public before() {
        if (!this.hasFrom) this.from(0);
        if (!this.hasTo) {this.to(0);this.resetAfter=true;}
    }

    public after() {
        super.after();
        if (this.resetAfter) this.element.css('clip-path','');
    }

    public from(top:number|string,right:number|string|null=null,bottom:number|string|null=null,left:number|string|null=null) {
            if (right===null) right=top;
        if (bottom===null) bottom=right;
        if (left===null) left=bottom;
        this.fromItem.css('clip-path','inset('+this.px(top)+' '+this.px(right)+' '+this.px(bottom)+' '+this.px(left)+')');
        this.hasFrom=true;
        return this;
    }

    public to(top:number|string,right:number|string|null=null,bottom:number|string|null=null,left:number|string|null=null) {
        if (right===null) right=top;
        if (bottom===null) bottom=right;
        if (left===null) left=bottom;
        this.toItem.css('clip-path','inset('+this.px(top)+' '+this.px(right)+' '+this.px(bottom)+' '+this.px(left)+')');
        this.hasTo=true;
        return this;
    }

}

export {};